import React, { useRef } from 'react';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useScopedTranslation } from '@common/utils/hooks/useScopedTranslation';
import { MeetingTypeLabel } from '@typings/api';
import { handleKeystroke } from '@utils/handleKeystroke';

interface Props {
  label: MeetingTypeLabel;
  icon: IconProp;
  onClick: (meeting: string) => void;
  selected?: boolean;
}

export function MeetingType(props: Props) {
  const { icon, label, onClick, selected = false } = props;
  const { t } = useScopedTranslation();
  const wrapper: React.Ref<HTMLDivElement> = useRef(null);

  function handleClick() {
    if (selected) {
      return;
    }

    return onClick(label);
  }
  const buttonText = selected ? t('button.chosen') : t('button.choose');

  return (
    <div
      className={` w-full border p-5 cursor-pointer flex flex-col justify-between relative transition-all duration-200 ${
        selected
          ? 'text-white bg-brand-400 border-brand-400'
          : 'text-gray-700 border-gray-300'
      }`}
      onClick={handleClick}
      onKeyDown={(e) => handleKeystroke(e.code)}
      ref={wrapper}
      title={t(
        `main_form.meeting_type.types.${label.toLowerCase()}.description`,
      )}
    >
      <div>
        <h3
          className={`text-xl pb-5 lg:pb-2.5 w-full lg:border-b border-gray-300 ${
            selected ? 'text-current font-medium' : 'text-brand-400 font-normal'
          }`}
        >
          <FontAwesomeIcon className="mr-2" icon={icon} size="sm" />
          {t(`main_form.meeting_type.types.${label.toLowerCase()}.label`)}
        </h3>
        <div className="hidden px-5 py-8 2xl:text-base text-sm lg:block">
          {t(`main_form.meeting_type.types.${label.toLowerCase()}.description`)}
        </div>
      </div>
      <button
        aria-label={
          buttonText +
          t(`main_form.meeting_type.types.${label.toLowerCase()}.label`)
        }
        className={`btn border w-48 ${
          selected
            ? 'text-white border-white focus:text-white focus:bg-brand-500 focus:border-white'
            : 'border-gray-700 group-hover:border-brand-400 group-hover:text-brand-400 focus:text-brand-400 focus:border-brand-400'
        }`}
        onClick={handleClick}
        type="button"
      >
        {buttonText}
      </button>
      <div className="absolute bottom-0 left-0 w-0 group-hover:w-full h-1 bg-brand-400 transition-width duration-300 ease-in" />
    </div>
  );
}
